import type { RankedSpace } from "../ai-mode/types";

export const PERFECT_MOCK_ID = "partner-demo-perfect-mock";

const ALL_AMENITIES = [
  "acesso-24-7",
  "controle-de-acesso-digital",
  "acessibilidade",
  "ar-condicionado",
  "mobiliado",
  "cortina-ou-persiana",
  "portas-automaticas",
  "sala-climatizada",
  "vidro-com-isolamento-acustico",
  "gerador",
  "endereco-comercial",
  "endereco-fiscal",
  "escritorio-virtual",
  "limpeza-da-sala",
  "cafe-no-espaco",
  "copa",
  "sala-de-reuniao",
  "janela",
  "certificacao-do-predio-leed-gold-etc",
  "cozinha-equipada",
  "detectores-de-fumaca",
  "estacionamento-no-local",
  "estacionamento-proximo",
  "impressao-colorida",
  "impressao-pb",
  "vpn-private-network-rede-privada",
  "scanner-digitalizadora",
  "wi-fi",
  "impressora",
  "internet-cabeada",
  "link-dedicado",
  "cftv-circuito-fechado-de-tv",
  "recepcionista",
  "seguranca-monitorada-24h",
  "sistemas-de-sprinklers",
  "vigilancia-nas-areas-comuns-e-estacionamento",
  "banheiro-privado",
  "telefone",
  "planta-do-imovel",
  "alvara-de-funcionamento",
];

const MOCK_IMAGES = [
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/25b7c02a-415d-4e8a-8ff5-c594b25ed406.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/8bb050b3-5279-4c7c-be00-51f01c2a1995.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/5151516d-0d3e-4e3f-9832-b87152ba4c38.png",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/da74531d-363c-4d8c-8778-b994aa92e624.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/549f7c3d-285e-4137-a0c1-b1fb09d637b1.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/ef615a90-0e9e-4366-8478-08d10b865aef.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/27d2e936-533a-45be-a44a-53f5b440003c.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/eb8377c7-c0d7-4ed2-b82c-596135ef8b2c.jpeg",
  "https://d1y4va1nna2r1p.cloudfront.net/spaces/6d437bfe-dbd7-4a1d-8da3-4733294aaf56.jpeg",
];

interface BuildPerfectMockParams {
  location: { label: string; lat: number; lng: number } | null;
  capacityMax?: number | null;
  capacityMin?: number | null;
}

export function buildPerfectMockSpace(
  params: BuildPerfectMockParams,
): RankedSpace {
  const { location, capacityMax, capacityMin } = params;

  const capacity = capacityMax ?? capacityMin ?? 20;
  const lat = location?.lat ?? -23.5505;
  const lng = location?.lng ?? -46.6333;
  const city = location?.label.split(",").pop()?.trim() ?? "São Paulo";

  return {
    id: PERFECT_MOCK_ID,
    spaceName: "Vitrine Ideal",
    roomName: "Modelo Woba",
    city,
    address: location?.label ?? "São Paulo",
    lat,
    lng,
    pricePerWorkstation: 0,
    monthlyPrice: null,
    credits: null,
    capacity,
    sizeM2: Math.max(capacity * 5, 40),
    score: 100,
    amenities: ALL_AMENITIES,
    imageUrl: MOCK_IMAGES[0],
    images: MOCK_IMAGES,
    isRecommended: true,
    salesPitch:
      "Este espaço representa a vitrine perfeita: todas as fotos de alta qualidade, dados completos e todas as comodidades devidamente cadastradas.",
    matchReasons: [
      "Cadastro 100% completo",
      "Fotos profissionais de todos os ambientes",
      "Planta do imóvel disponível",
      "Todos os documentos cadastrados",
    ],
  };
}
